import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AnimatedBackground from '../components/AnimatedBackground';
import { fireEvent } from '../utils/funnelEvents';
import ArticleStructuredData from '../components/ArticleStructuredData';
import EngineeringHeader from '../components/EngineeringHeader';

import EngineeringHero from './engineering/EngineeringHero';
import Workflow from './engineering/Workflow';
import PainPoints from './engineering/PainPoints';
import LocalFirst from './engineering/LocalFirst';
import Pricing from './engineering/Pricing';
import EngineeringFAQ from './engineering/EngineeringFAQ';
import ContactInfo from './engineering/ContactInfo';

const PAGE_TITLE = 'Sortio for Engineering: AI File Organization for CAD, BOQs, and Project Archives';
const PAGE_DESCRIPTION =
  'Sortio organizes engineering project files on your Mac: CAD drawings by discipline (AR, ST, PW, TR), change requests (CRF, RFI), BOQs, MOMs, and 7,000+ file project archives. On device AI keeps client IP private. Built for AEC, telecom, and infrastructure project managers.';

const EngineeringPage = () => {
  useEffect(() => {
    fireEvent('team_page_view', { vertical: 'engineering' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta
          name="keywords"
          content="engineering project file management, CAD drawing organizer, AEC document management, construction project file organization, AI sort engineering files, telecom project archive software, engineering BOQ MOM organizer, CAD revision file management, DWG file organizer, change request CRF tracking, RFI tracking, BIM coordinator tools"
        />
        <link rel="canonical" href="https://www.getsortio.com/for-engineering" />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:url" content="https://www.getsortio.com/for-engineering" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={PAGE_TITLE} />
        <meta name="twitter:description" content={PAGE_DESCRIPTION} />
      </Helmet>
      <ArticleStructuredData
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        datePublished="2026-05-12T00:00:00.000Z"
        dateModified="2026-05-12T00:00:00.000Z"
        authorName="Sortio Team"
      />

      <EngineeringHeader />
      <EngineeringHero />

      <div className="relative">
        <AnimatedBackground variant="business" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
          <Workflow />
          <PainPoints />
          <LocalFirst />
          <Pricing />
          <EngineeringFAQ />
          <ContactInfo />
        </div>
      </div>
    </>
  );
};

export default EngineeringPage;
